export const ageOptions = [
  { value: "18-25", label: "18-25" },
  { value: "25-30", label: "25-30" },
  { value: "30-35", label: "30-35" },
  { value: "35-50", label: "35-50" },
  { value: "50-60", label: "50-60" },
  { value: "others", label: "Others" },
];

export const foodOptions = [
  { value: "veg", label: "Veg" },
  { value: "nonveg", label: "Non Veg" },
];
